// src/web/client/src/components/PageTabs.jsx
//
// THE one in-page navigation for every page of the app (UX brief, Phase B):
// the same Radix tab strip everywhere — no button rows, no emoji, no per-page
// variant. The selected tab lives in the URL (?tab=) so a reload, a shared
// link and a redirect from an old route (/reviews → /automations?tab=reviews)
// all land on the same tab. Unknown or missing ?tab → the first tab.
//
//   <PageTabs tabs={[{ id, label, render }]} />
//
// `render` is called only for the selected tab, so a tab's data is fetched only
// when it is opened.

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

export default function PageTabs({ tabs, param = 'tab', className = '' }) {
  const [params, setParams] = useSearchParams();
  const ids = tabs.map((t) => t.id);
  const fromUrl = params.get(param);
  const selected = ids.includes(fromUrl) ? fromUrl : ids[0];

  const select = (id) => {
    const next = new URLSearchParams(params);
    if (id === ids[0]) next.delete(param); else next.set(param, id);
    setParams(next, { replace: true });
  };

  return (
    <Tabs value={selected} onValueChange={select} className={className}>
      <TabsList aria-label="Sections" className="h-auto flex-wrap justify-start gap-1 bg-gray-100">
        {tabs.map((t) => (
          <TabsTrigger key={t.id} value={t.id} className="px-4 py-1.5">{t.label}</TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((t) => (
        <TabsContent key={t.id} value={t.id} className="mt-4">
          {selected === t.id ? t.render() : null}
        </TabsContent>
      ))}
    </Tabs>
  );
}
